module.exports = __webpack_public_path__ + "imgcvh/hero-8.ac185d1d.jpg";